import { render, staticRenderFns } from "./InvoicesCurrent.vue?vue&type=template&id=c8c93fe6&scoped=true"
import script from "./InvoicesCurrent.vue?vue&type=script&lang=ts&setup=true"
export * from "./InvoicesCurrent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./InvoicesCurrent.vue?vue&type=style&index=0&id=c8c93fe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c8c93fe6",
  null
  
)

export default component.exports